import { some } from 'lodash'

import { WPPageData } from '@/types'

export const pageHasHero = (pageProps?: WPPageData) => {
  const sections = pageProps?.acf?.builder || []
  return some(sections, ({ acf_fc_layout, media }: any) => {
    return (
      (acf_fc_layout.includes('product-hero') && media?.image) ||
      (acf_fc_layout.includes('home-hero') && media?.image) ||
      (acf_fc_layout.includes('full-hero') && media?.image) ||
      (acf_fc_layout.includes('hero') && media?.image)
    )
  })
}

export const pageHasWebgl = (pageProps?: WPPageData) => {
  const sections = pageProps?.acf?.builder || []
  return some(sections, ({ acf_fc_layout }: any) => {
    return acf_fc_layout.includes('webgl')
  })
}
